
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.735 17.205c-1.89-.152-3.771-1.004-5.05-2.498-.597-1.09 1.037-1.74 1.537-.732 2.022 1.89 5.24 2.095 7.462.47 1.893-1.316 2.957-3.769 2.693-6.136-.277-2.964-2.707-5.49-5.526-5.735-2.279-.253-4.62.95-5.826 3.001-.786 1.217-.96 2.722-.944 4.157.639-.752.676-.743 1.348-1.463.825-.759 1.977-.018 1.215.774-4.009 4.481-3.094 4.691-6.541.094-.464-1.174.752-1.785 1.428-.789.403.476.545.609.944 1.088.01-1.89.39-3.885 1.599-5.348C5.789 1.683 8.817.446 11.623 1.005c3.115.551 5.728 3.302 6.251 6.583.524 2.935-.617 6.113-2.883 7.917-1.478 1.228-3.384 1.808-5.256 1.7z"}})])
          )
        }
      }
    